import {EventEmitter, Injectable, Output} from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponse } from '../models/response/BaseResponse';
import { HttpService } from './http.service';
import {User} from '../models/User';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends HttpService{

  @Output() userlogin = new EventEmitter<User>();

  isUserLogged(): boolean{
    return !!localStorage.getItem('token');
  }

  get loginPath(): string{
    return this.environmentPath + 'login';
  }

  login(web_identifier: string): Observable<BaseResponse<{user: User, factorial_identifier: string}>>{
    return this.post('login', {web_identifier});
  }

  logout(): void{
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('factorial_identifier');
  }

  getUser(): User | null{
    const user = localStorage.getItem('user');
    if (!user) {
      return null;
    }

    try {
      return JSON.parse(user) as User;
    } catch {
      return null;
    }
  }

  // public hasRole(roleString: string): boolean{
  //   // @ts-ignore
  //   return this.getUser().roles?.filter(role => (role.code === roleString)).length > 0;
  // }

  // public isActive(): boolean{
  //   return this.getUser().is_active ?? false;
  // }

}
